module.exports = __webpack_public_path__ + "media/images/bg-circle-bbdd55ce2b4e64f4dc10998edd113c52.svg";